import axios from "axios";
import { useTranslation } from "react-i18next";
import useProgressState from "../useProgressState";
import { showErrortMessage } from "../../shared/helpersMethod";
import { URL_CONSTANTS } from "../../axios/urlLinksThemes";
URL_CONSTANTS;
const useNcdOtp = () => {
  const { t } = useTranslation();
  const bearerToken =
    "pRVAlK1u5dv76dDjTMn03Pp6vg6hp2kPZ9OkuMjO2h8MABquPUXPGKaWiOr5";

  const headers = {
    "Content-Type": "text/plain",
    Authorization: `Bearer ${bearerToken}`,
  };
  const { loading, setLoading, setSuccess, setFailure, success, failure } =
    useProgressState();
  const sendOtpHandler = async (mobileNumber: string) => {
    try {
      setLoading();
      const response = await axios.post(
        URL_CONSTANTS.get("URL_SEND_SIGNAL_OTP"),

        {
          digits: 4,
          mobile: mobileNumber,
          templateName: "otp",
          fromMobile: "+9647722776226",
          lang: "ar",
          sender: "NCD-APP",
        },
        { headers: headers }
      );
      //   httpPostWithAuth(
      //     '',
      //     {
      //       digits: 4,
      //       mobile: mobileNumber,
      //       templateName: 'dukanyotp_en_ar',
      //       fromMobile: '+9647853908489',
      //       lang: 'ar',
      //       sender: 'NCD-APP',
      //     },
      //     bearerToken,
      //   );
      console.log(response.data);
      if (response.data.type !== "error") {
        setSuccess();
        return response.data;
      } else {
        setFailure();
        Alert.alert("", response.data.message);
      }
    } catch (error) {
      Alert.alert("", error.response.data.message);
      setFailure();
    }
  };
  const validateOtpHandler = async (otp: string, otpReqId: string) => {
    try {
      setLoading();
      const response = await axios.post(
        URL_CONSTANTS.get("URL_VALIDATE_SIGNAL_OTP"),
        {
          otp,
          otpReqId,
        },
        { headers: headers }
      );
      //   httpPostWithAuth(
      //     '',
      //     {
      //       digits: 4,
      //       mobile: mobileNumber,
      //       templateName: 'dukanyotp_en_ar',
      //       fromMobile: '+9647853908489',
      //       lang: 'ar',
      //       sender: 'NCD-APP',
      //     },
      //     bearerToken,
      //   );

      if (response.data.type !== "error") {
        setSuccess();
        return response.data;
      } else {
        setFailure();
        showErrortMessage(
          response.data.message == "OTP Validation Failed"
            ? t("txt_invalid_otp")
            : response.data.message,
          2000
        );
        // Alert.alert(
        //   response.data.message == "OTP Validation Failed"
        //     ? t("otp_val_failed")
        //     : response.data.message
        // );
      }
    } catch (error) {
      // Alert.alert(
      //   error.response.data.message == "OTP Validation Failed"
      //     ? t("otp_val_failed")
      //     : error.response.data.message
      // );
      showErrortMessage(
        error.response.data.message == "OTP Validation Failed"
          ? t("otp_val_failed")
          : error.response.data.message
      );
      setFailure();
    }
  };
  return {
    sendNcdOtpHandler: sendOtpHandler,
    validateOtpHandler,
    ncdOtpLoading: loading,
    ncdOtpsuccess: success,
  };
};

export default useNcdOtp;
